module.exports = __webpack_public_path__ + "img/footer-code.f18b6884.png";